export enum PAGE {
  AMC = 'AMC',
  AMAZON_AMC_AUDIENCES = 'amazon-amc-audiences',
  SELLICS_JOINS_PERPETUA = 'Sellics Joins Perpetua',
  PAGE_404 = '404',
  BUSINESS_INTELLIGENCE = 'business-intelligence',
  PRICING = 'pricing',
  AMAZON_SEO_TOOL = 'amazon-seo-tool',
  VIDEO_ADS = 'video-ads',
  COMPETITOR = 'competitor',
  AMAZON_PPC = 'amazon-ppc',
  AMAZON_ACCELERATOR_PROGRAM = 'amazon-accelerator-program',
  PRISM = 'prism',
  WEBINARS = 'webinars',
  BLOG = 'blog',
  BLOG_CATEGORY = 'blog-category',
  BLOG_SEARCH = 'blog-search',
  BLOG_POST = 'blog-post',
  VIDEO = 'video',
  RESOURCES = 'resources',
  STARTUP = 'startup',
  NEWSLETTER = 'newsletter'
}
